__webpack_require__.p = "/pl/bip-kalkulator/";